
import { Component, Vue, Prop } from 'vue-property-decorator';
import toISODateFormatter from '@/filters/toISOdate.formatter';

@Component({
    props: {
        date: Date
    },
    filters: {
        toISODate: toISODateFormatter
    }
})

export default class DatePicker extends Vue {

}
